var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.290039 3.68795V20.4403C0.290039 22.1463 1.71905 23.5753 3.42502 23.5753H20.1771C21.8831 23.5753 23.3121 22.1463 23.3121 20.4403V14.1214C23.3121 13.1386 21.9589 12.6919 21.3719 13.5527C21.1501 13.8778 21.2058 14.2037 21.2058 14.7093L21.2059 19.9996C21.2092 20.8648 21.0118 21.469 19.9813 21.469H3.62089C2.81648 21.469 2.39634 21.0487 2.39634 20.2445V3.88395C2.39634 2.90891 2.9453 2.65443 3.81653 2.65902L9.10698 2.65938C9.62524 2.65938 9.94075 2.72246 10.2755 2.50531C11.2206 1.89195 10.6914 0.55307 9.74378 0.55307H3.42502C1.71591 0.55307 0.290039 1.98173 0.290039 3.68795Z",
    fill: "#ADAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7723 11.5743C10.7723 10.611 10.7723 9.64767 10.7723 8.68423C10.7723 8.17297 10.8336 7.74774 10.6425 7.39345C10.0864 6.36259 8.66602 6.86696 8.66602 7.80248V14.2193C8.66602 14.7263 9.13861 15.1989 9.64563 15.1989H16.0624C16.9803 15.1989 17.4955 13.8037 16.5029 13.2399C16.1284 13.0272 15.7438 13.0926 15.1807 13.0926C14.2174 13.0926 13.2539 13.0926 12.2906 13.0926C12.454 12.8485 21.7237 3.62853 22.8343 2.52444C23.9275 1.43775 22.918 0.552856 22.2832 0.552856C21.6238 0.552856 21.2683 1.10242 20.6545 1.71616C20.169 2.20168 19.7195 2.65119 19.234 3.13672C18.7533 3.61741 11.0146 11.4118 10.7722 11.5741L10.7723 11.5743Z",
    fill: "#ADAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMini);
export default __webpack_public_path__ + "static/media/mini.0ef7e9a429c2d34dbb0c556b6b4a3bbf.svg";
export { ForwardRef as ReactComponent };